import React, { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { useMutation } from "@apollo/client";
import { Row, Col, Table, Button, Modal, Form, Alert } from "react-bootstrap";
import { ADJUNTO_EMPRESA } from "./../../utils/graphql_query";
import {
  ADD_ADJUNTO_EMPRESA,
  DELETE_ADJUNTO_EMPRESA,
} from "./../../utils/graphql_mutation";
import { useQuery } from "@apollo/client";
import Errors from "../base/Errors";
import LoadingPage from "../base/LoadingPage";
import { uploadFileS3 } from "../../utils/helpers";
import moment from "moment";
import { trimLastKey } from "./galeriaImagenes";

const DocumentacionEmpresa = ({ empresa_id }) => {
  const { data, loading, refetch, error } = useQuery(ADJUNTO_EMPRESA, {
    variables: { empresa_id: empresa_id },
  });
  const [showModal, setShowModal] = useState(false);
  const [modDelete, setModDelete] = useState(false);
  const [ldAccion, setLdAccion] = useState(false);
  const [complet, setComplet] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [selectedElement, setselectedElement] = useState(undefined);
  const [descriptionFile, setDescriptionFile] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const [addAdjuntoEmpresa] = useMutation(ADD_ADJUNTO_EMPRESA);
  const [deleteAdjuntoEmpresa] = useMutation(DELETE_ADJUNTO_EMPRESA);

  const handleClose = () => {
    setShowModal(false);
    setSelectedFiles([]);
    setPreviewFiles([]);
    setDescriptionFile("");
  };
  const handleShow = () => setShowModal(true);
  const handleCloseModDelete = () => setModDelete(false);
  const handleShowModDelete = () => setModDelete(true);

  const handleFiles = useCallback((files) => {
    const fileList = Array.from(files);
    if (fileList.length === 0) return;

    const newPreviews = fileList.map((file) => ({
      name: file.name,
      size: (file.size / 1024).toFixed(1) + " KB",
      type: file.type,
    }));
    setSelectedFiles((prev) => [...prev, ...fileList]);
    setPreviewFiles((prev) => [...prev, ...newPreviews]);
  }, []);

  useEffect(() => {
    const handlePaste = (e) => {
      if (!showModal) return;
      const items = e.clipboardData?.items;
      if (!items) return;

      const fileList = [];
      for (let item of items) {
        if (item.kind === "file") {
          fileList.push(item.getAsFile());
        }
      }

      if (fileList.length > 0) {
        e.preventDefault();
        handleFiles(fileList);
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [showModal, handleFiles]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const selectFile = (event) => {
    handleFiles(event.target.files);
  };

  const removeFile = (index) => {
    const newFiles = [...selectedFiles];
    const newPreviews = [...previewFiles];
    newFiles.splice(index, 1);
    newPreviews.splice(index, 1);
    setSelectedFiles(newFiles);
    setPreviewFiles(newPreviews);
  };

  const onChangeDescription = (e) => {
    if (e.target.value !== "") {
      e.target.className = "form-control is-valid";
    }
    setDescriptionFile(e.target.value);
  };

  const saveDocuments = async () => {
    if (selectedFiles.length === 0 || descriptionFile === "") {
      let txtArea = document.getElementById("txtDescription");
      if (txtArea && descriptionFile === "") {
        txtArea.className = "form-control is-invalid";
      }
      if (selectedFiles.length === 0) {
        document.getElementById("fileInput").className =
          "form-control is-invalid";
      }
      return;
    }

    setBtnDisabled(true);
    setLdAccion(true);

    try {
      for (const file of selectedFiles) {
        const upload = await uploadFileS3({
          data: file,
          filename: "file.pdf",
          prefix: `empresa`,
        });
        await addAdjuntoEmpresa({
          variables: {
            nombre: upload?.key,
            descripcion: _.trim(descriptionFile),
            empresa_id: empresa_id,
          },
        });
      }
      refetch();
      setComplet(true);
    } catch (err) {
      console.error("Error uploading files:", err);
    }

    setBtnDisabled(false);
    setLdAccion(false);
    setTimeout(() => {
      setComplet(false);
      setDescriptionFile("");
      setSelectedFiles([]);
      setPreviewFiles([]);
      setShowModal(false);
    }, 1000);
  };

  const handleClickOpen = ({ nameFile, isOld }) => {
    const folderTest = process.env.REACT_APP_AWS_S3_FOLDER_TEST
      ? process.env.REACT_APP_AWS_S3_FOLDER_TEST
      : "";
    if (isOld) {
      window.open(
        `${process.env.REACT_APP_AWS_S3_URL}/empresa${folderTest}/${nameFile}`
      );
      return;
    }

    window.open(
      `${process.env.REACT_APP_AWS_S3_URL}/empresa${folderTest}/${trimLastKey(
        nameFile
      )}`
    );
  };

  const handleClickSetElement = (value) => {
    handleShowModDelete();
    setselectedElement(value);
  };

  const handleDeletElement = async () => {
    setLdAccion(true);
    const {
      data: { deleteAdjuntoEmpresa: result },
    } = await deleteAdjuntoEmpresa({
      variables: { id: selectedElement.id },
    });
    if (parseInt(result.id) > 0) {
      refetch();
    }
    setLdAccion(false);
    setComplet(true);
    setTimeout(() => {
      setComplet(false);
      setModDelete(false);
    }, 1000);
  };

  const createTitle = (obj) => {
    let extension = obj.nombre_archivo.split(".");
    return obj.nombre_descargar + "." + extension[1];
  };

  if (loading) return <LoadingPage />;
  if (error) return <Errors error={error} />;
  if (!data.adjuntos_empresa) return "No existe informacion";

  return (
    <>
      <h5 className="">Documentos Adjuntos</h5>

      <div className="mb-2">
        <Button className="btn-primary me-2" size="sm" onClick={handleShow}>
          <i className="fa fa-plus"></i> Agregar
        </Button>
      </div>

      <Table striped bordered hover className="shadow bg-white">
        <thead>
          <tr className="text-center">
            <th>Archivo</th>
            <th>Fecha</th>
            <th>Descripci&oacute;n</th>
            <th>Acci&oacute;n</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td>Cargando...</td>
            </tr>
          ) : (
            <>
              {data.adjuntos_empresa.length === 0 ? (
                <tr>
                  <td colSpan="4">No existe informaci&oacute;n.</td>
                </tr>
              ) : (
                _.map(data.adjuntos_empresa, (value, key) => {
                  return (
                    <tr key={key}>
                      <td className="text-center">
                        <Button
                          id="linkDocument"
                          variant="link"
                          style={{ lineHeight: "1" }}
                          onClick={() =>
                            handleClickOpen({
                              nameFile: value.nombre_descargar,
                              //hardcoded old way to load files
                              isOld: moment(value.fecha, "YYYY-MM-DD").isBefore(
                                moment("2024-08-15", "YYYY-MM-DD")
                              ),
                            })
                          }
                          title={createTitle(value)}
                        >
                          <i
                            className="fas fa-file-download"
                            style={{ fontSize: "20px" }}
                            data-link={value.nombre_archivo}
                            data-newname={value.nombre_descargar}
                          />
                          {/* <br /> */}
                          <span className="ms-2">Descargar</span>
                        </Button>
                      </td>
                      <td className="text-center">
                        {moment(value.fecha, "YYYY-MM-DD").format("DD/MM/YYYY")}
                      </td>
                      <td>{value.descripcion}</td>
                      <td className="text-center">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleClickSetElement(value)}
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })
              )}
            </>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleClose} backdrop="static" size="md">
        <Modal.Body className="p-4">
          <Form.Group as={Row}>
            <Form.Label column sm={12}>
              Descripcion
            </Form.Label>
            <Col sm={12}>
              <Form.Control
                as="textarea"
                id="txtDescription"
                rows="2"
                value={descriptionFile}
                onChange={onChangeDescription}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formPlaintextEmail">
            <Form.Label column sm={12}>
              Archivos
            </Form.Label>
            <Col sm={12}>
              <div
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  border: isDragging
                    ? "3px dashed #0d6efd"
                    : "3px dashed #dee2e6",
                  borderRadius: "8px",
                  padding: "20px",
                  textAlign: "center",
                  backgroundColor: isDragging ? "#f8f9fa" : "transparent",
                  transition: "all 0.2s ease",
                }}
              >
                {previewFiles.length > 0 ? (
                  <div className="mb-3">
                    {previewFiles.map((file, index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center mb-2 p-2"
                        style={{ background: "#f8f9fa", borderRadius: "4px" }}
                      >
                        <div className="text-start">
                          <i className="fas fa-file-alt me-2"></i>
                          <span style={{ fontSize: "13px" }}>{file.name}</span>
                          <span
                            className="text-muted ms-2"
                            style={{ fontSize: "11px" }}
                          >
                            ({file.size})
                          </span>
                        </div>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeFile(index)}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : null}

                {previewFiles.length > 0 && (
                  <div
                    className="mb-2"
                    style={{ fontSize: "13px", color: "#6c757d" }}
                  >
                    {selectedFiles.length} archivo(s) seleccionado(s)
                  </div>
                )}

                <Form.Control
                  type="file"
                  id="fileInput"
                  onChange={selectFile}
                  multiple
                  style={{ display: "none" }}
                />
                <label
                  htmlFor="fileInput"
                  className="btn btn-outline-primary"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fas fa-plus"></i> Seleccionar Archivos
                </label>
                <p
                  className="mt-2 mb-0"
                  style={{ fontSize: "12px", color: "#adb5bd" }}
                >
                  Arrastra archivos aquí o pépalos (Ctrl+V)
                </p>
              </div>
            </Col>
          </Form.Group>
          {ldAccion ? <Alert variant="success">Cargando...</Alert> : ""}
          {complet ? (
            <Alert variant="success">Cargado(s) Correctamente.</Alert>
          ) : (
            ""
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Salir
          </Button>
          <Button
            variant="primary"
            disabled={btnDisabled || selectedFiles.length === 0}
            onClick={saveDocuments}
          >
            Guardar{" "}
            {selectedFiles.length > 0 ? `(${selectedFiles.length})` : ""}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modDelete}
        onHide={handleCloseModDelete}
        backdrop="static"
        size="md"
      >
        <Modal.Body className="p-4">
          <div>Se Necesita Confirmaci&oacute;n Para Eliminar.</div>
          {ldAccion ? <Alert variant="success">Cargando...</Alert> : ""}
          {complet ? (
            <Alert variant="success">Eliminado Correctamente.</Alert>
          ) : (
            ""
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModDelete}>
            Salir
          </Button>
          <Button variant="primary" onClick={handleDeletElement}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentacionEmpresa;
